//setEscrowState 0

import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import DisplayedWeiData from '../DisplayedWeiData'

import { Web3StatusContext } from "../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class ResetEscrow extends React.Component {
  static contextType = Web3StatusContext;

  state = { 
    stackId: -1,
  };

  activeAccount = null;

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    var stackId;
    stackId = GAMEFORESTSale.methods.setEscrowState.cacheSend(0);
    this.setState({ stackId: stackId });
  }

  render() {

    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    return (
      <div>
          <form onSubmit={this.mySubmitHandler}>
            0 Active
            <br/>
            <input
            type='submit'
            value="Set State Active"
            />
          </form>
      </div>
    );
  }
};

export default ResetEscrow;
